const getters = {
  isMobile: state => state.app.isMobile,
  lang: state => state.app.lang,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  isLogin: state => state.user.isLogin,
  isVip: state => state.user.isVip,
  vipInfo: state => state.user.vipInfo,
  addRouters: state => state['async-router'].addRouters,
  multiTab: state => state.app.multiTab,
  loading: state => state.app.loading,
  processing: state => state.app.processing,
  enterpriseId: state => state.user.info?.enterpriseInfoDto?.enterpriseId,
  enterpriseName: state => state.user.info?.enterpriseInfoDto?.enterpriseName
}

export default getters
